import { Input, Modal } from "antd";
import { useEffect, useRef } from "react";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

const CustomerInformation = ({
  customerOpen,
  setCustomerOpen,
  handleOk,
  handleCancel,
  customerArea,
  setCustomerArea,
  customerName,
  setCustomerName,
  customerMobile,
  setCustomerMobile,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (customerOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [customerOpen]);
  return (
    <Modal
      className="ci-modal"
      title={<div className="ci-title">Customer Details</div>}
      open={customerOpen}
      onOk={handleCancel}
      onCancel={handleCancel}
      closable={false}
      okText="OK"
      cancelText="Cancel"
      maskStyle={{
        backdropFilter: "blur(8px)", // <- this applies the blur effect
        backgroundColor: "rgba(0, 0, 0, 0.2)", // optional: tint the background a little
      }}
      afterOpenChange={(open) => {
        if (open && inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      {/* ---------- embedded styles (single file) ---------- */}
      <style>{`
        .ci-modal .ant-modal-content{padding:0;border-radius:18px;overflow:hidden}
        .ci-modal .ant-modal-header{margin:0;padding:0;background:transparent}
        .ci-modal .ant-modal-body{padding:14px;background:#eef1f8}
        .ci-modal .ant-modal-footer{margin:0;padding:4px 14px 14px;background:#eef1f8;display:flex;gap:10px}
        .ci-modal .ant-modal-footer .ant-btn{flex:1;height:42px;border-radius:12px;font-weight:800}
        .ci-modal .ant-modal-footer .ant-btn-primary{background:linear-gradient(135deg,#162566,#2a3c8f);border:0}

        .ci-title{background:linear-gradient(135deg,#162566,#2a3c8f);color:#fff;font-weight:800;font-size:16px;text-align:center;padding:14px 12px;letter-spacing:.4px}

        .ci-preview{display:flex;align-items:center;gap:12px;background:linear-gradient(135deg,#1f8f6a,#52bd91);color:#fff;border-radius:14px;padding:10px 14px;box-shadow:0 4px 12px rgba(31,143,106,.3)}
        .ci-avatar{width:42px;height:42px;border-radius:50%;background:#f7c948;color:#3b2a00;font-weight:800;font-size:18px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
        .ci-pname{font-weight:800;font-size:14px;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
        .ci-pmeta{font-size:12px;font-weight:600;color:#fff6c2;min-height:16px}

        .ci-form{margin-top:12px;display:flex;flex-direction:column;gap:10px}
        .ci-field{background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:8px 12px 10px;box-shadow:0 1px 4px rgba(0,0,0,.05)}
        .ci-label{display:flex;align-items:center;gap:6px;font-size:11px;font-weight:800;color:#6b76a8;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px}
        .ci-label svg{font-size:16px!important;color:#162566}
        .ci-input{height:40px;border-radius:10px!important;font-size:16px;font-weight:700;color:#162566}
      `}</style>

      {/* live preview (display only) */}
      <div className="ci-preview">
        <div className="ci-avatar">
          {(customerName || "").trim()
            ? customerName.trim().charAt(0).toUpperCase()
            : "+"}
        </div>
        <div style={{ minWidth: 0 }}>
          <div className="ci-pname">{customerName || "New customer"}</div>
          <div className="ci-pmeta">
            {[customerArea, customerMobile].filter(Boolean).join(" - ")}
          </div>
        </div>
      </div>

      <div className="ci-form">
        <div className="ci-field">
          <div className="ci-label">
            <PhoneIphoneIcon /> Contact No
          </div>
          <Input
            placeholder="Enter Customer No"
            className="ci-input"
            ref={inputRef}
            inputMode="numeric"
            value={customerMobile}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              if (value.length <= 10) {
                setCustomerMobile(value);
              }
            }}
          />
        </div>

        <div className="ci-field">
          <div className="ci-label">
            <PersonOutlineIcon /> Name
          </div>
          <Input
            placeholder="Enter Customer Name"
            className="ci-input"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
          />
        </div>

        <div className="ci-field">
          <div className="ci-label">
            <LocationOnOutlinedIcon /> City
          </div>
          <Input
            placeholder="Enter Area"
            className="ci-input"
            value={customerArea}
            onChange={(e) => setCustomerArea(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CustomerInformation;